// extracted by mini-css-extract-plugin
module.exports = {"heading":"CultureComponent_heading__3UHLI","headingContent":"CultureComponent_headingContent__1pkwq","contents":"CultureComponent_contents__3Kwh6"};